var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "70px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M180.9,130.9v37c-7.1,0.9-13.6,3.7-19,7.9c-9.3,7.2-15.3,18.5-15.3,31.3c0,10.1,3.8,19.4,10.1,26.4V256 h-97v-30.5H53c-9.6,0-17.4-7.8-17.4-17.4v-77.2c0-23.8,19.4-43.2,43.2-43.2h1.5l16.4,76.4l12,54.2l27.7-120.7l0.4-1.5l1.9-8.4 C162,88.2,180.9,107.4,180.9,130.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F68F6F",
    points: "115.2,111.4 120.9,164.9 112.7,200.4 108.6,218.3 104.4,200.5 96.6,164.1 102.2,111.4  98.5,100.9 95.7,92.9 121.8,92.9 118.9,100.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M108.7,84c-23.2,0-42-18.8-42-42s18.8-42,42-42c23.2,0,42,18.8,42,42S131.9,84,108.7,84z M108.7,3.1 C87.3,3.1,69.9,20.6,69.9,42s17.4,38.9,38.9,38.9c21.4,0,38.9-17.4,38.9-38.9S130.2,3.1,108.7,3.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD552",
    d: "M108.7,77.2c-19.4,0-35.2-15.8-35.2-35.2S89.3,6.8,108.7,6.8C128.2,6.8,144,22.6,144,42 S128.2,77.2,108.7,77.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M54.5,232.3H53c-13.4,0-24.2-10.9-24.2-24.2v-77.2c0-27.5,22.4-50,50-50h59c27.5,0,50,22.4,50,50v36.6 h-3.1v-36.6c0-25.8-21-46.8-46.8-46.8h-59c-25.8,0-46.8,21-46.8,46.8v77.2c0,11.6,9.5,21.1,21.1,21.1h1.5V232.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.9,
    y: 158.1,
    fill: "#4A555F",
    width: 3.1,
    height: 97.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 238.3,
    fill: "#4A555F",
    width: 3.1,
    height: 17.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.4,
    y: 158.1,
    fill: "#4A555F",
    width: 3.1,
    height: 17.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M116.4,113h-15.3l-7.6-21.6H124L116.4,113z M103.3,109.8h10.9l5.4-15.3H97.9L103.3,109.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "119.3,165 113.9,113 103.6,113 98.2,164.2 95.1,163.9 100.8,109.8 116.7,109.8 122.4,164.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M85.7,120.6l-8.5-39.7H93l7.2,20.3L85.7,120.6z M81,84l6.3,29.2l9.4-12.5L90.8,84H81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M132.4,121.7l-15.1-20.5l7.2-20.3h17.3L132.4,121.7z M120.8,100.7l10,13.7l7-30.3h-11.1L120.8,100.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M110.1,219.3l-3.1,0l-12-54.9L77.6,82.8l1.5-1.9h60.7l1.5,1.9l-18.9,82.4L110.1,219.3z M81,84l0.7,3.3 l16.4,76.4l10.5,48l10.7-47.2L137.8,84H81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M186.1,248.1c-22.7,0-41.1-18.4-41.1-41.1s18.4-41.1,41.1-41.1s41.1,18.4,41.1,41.1 S208.8,248.1,186.1,248.1z M186.1,169.1c-20.9,0-38,17-38,38s17,38,38,38s38-17,38-38S207.1,169.1,186.1,169.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#71CDE1",
    d: "M186.1,241.3c-18.9,0-34.3-15.4-34.3-34.3c0-18.9,15.4-34.3,34.3-34.3c18.9,0,34.3,15.4,34.3,34.3 C220.4,226,205,241.3,186.1,241.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 242.7,
    fill: "#4A555F",
    width: 3.1,
    height: 13.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184.6,
    y: 183,
    fill: "#4A555F",
    width: 3.1,
    height: 49.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 161.5,
    y: 206.1,
    fill: "#4A555F",
    width: 49.3,
    height: 3.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.d1609fc6fcfc7e5936139123a05d2050.svg";
export { ForwardRef as ReactComponent };